import PropTypes from 'prop-types'

import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import {classes, LinearProgressBar} from './SummaryComponentStyles'

const SummaryLinearProgressBar = ({data}) => {
  return data?.map((item, index) => (
    <Box key={index + item} tabIndex={0} aria-label={`${item.title}, ${Math.round(item.value)}%`}>
      <Typography variant='body2'>{item.title}</Typography>
      <Box className={classes.summaryLinearProgressBox}>
        <Box className={classes.summaryLinearProgressBox2}>
          <LinearProgressBar variant='determinate' value={item.value} />
        </Box>
        <Box className={classes.summaryLinearProgressBox3}>
          <Typography variant='body2'>{`${Math.round(item.value)}%`}</Typography>
        </Box>
      </Box>
    </Box>
  ))
}

SummaryLinearProgressBar.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */

  data: PropTypes.array.isRequired
}

export default SummaryLinearProgressBar
